import React from "react";
import AlertData from "../../api/AlertData";
import { observer } from "mobx-react-lite";

export const FilterTagError = observer(() => {
  return (
    <div className="alert-center-filters">
      {AlertData.filter_collection
        .filter((f) => f.visible)
        .map((f) => (
          <button
            key={f.name}
            type="button"
            onClick={() => AlertData.setActiveTagFilterCollection(f)}
            className={`subscription-period-chip${
              f.active ? " subscription-period-chip--active" : ""
            }`}
          >
            {f.nameRU}
          </button>
        ))}
    </div>
  );
});
